import React, { Component, useState } from "react";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import { postData, getData, patchData, deleteData } from '../../util/Fetch';
import { Button } from "reactstrap";
import { styled } from '@mui/material/styles';
import { Route } from "@mui/icons-material";
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));


const Login = () => {
    const history = useHistory();

    const [loginData, setloginData] = React.useState({
        Account: "",
        Password: ""
    });

    const handleSubmit = (event) => {
        postData("Login/Login", loginData).then(res => {
            if (res === 'ok') {
                history.push('/eventCalander');
            }
            else{
                swal("登入失敗", res, "error");
            }
        });
    };

    const handleChange = e => {
        setloginData({ ...loginData, [e.currentTarget.id]: e.currentTarget.value });
    };

    return (
        <Box sx={{
            width: '100%',
            marginLeft: '25%',
            marginTop: '20%'
        }}>
            <Stack spacing={2} sx={{ width: '50%' }}>
                <TextField id="Account" label="帳號" onChange={handleChange} required variant="outlined" />
            </Stack>
            <Stack spacing={2} sx={{ width: '50%', marginTop: '2%' }}>
                <TextField id="Password" label="密碼" onChange={handleChange} required variant="outlined" type="password"
                onKeyPress={(e) => {
                    if (e.key === "Enter") {
                        handleSubmit();
                    }
                  }}
                   />
            </Stack>
            <Stack spacing={2} sx={{ width: '50%', marginTop: '2%' }}>
                <Button variant="contained" onClick={handleSubmit}>登入</Button>
            </Stack>
        </Box>
    );
}

export default Login
